<template>
  <create-account-layout
    :current-step="3"
    title="Your Profile"
  >
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div>
        <p class="my-6 text-left text-dark-gray">
          Let's get some basic information.
        </p>
        <div>
          <form-field
            label="Full Name"
            :value="full_name"
            placeholder="Enter your full name"
            :on-input="handleFieldUpdate"
            :error="full_name_error"
            :alert-message="full_name_alert"
            name="full_name"
          />
          <form-field
            v-if="!isEmailRequiredForLogin"
            label="Company Email"
            :value="email_address"
            placeholder="Enter your company email"
            :on-input="handleFieldUpdate"
            :on-blur="checkEmailAddress"
            :error="email_address_error"
            name="email_address"
          />
        </div>
        <button-main
          class="mb-4 mt-3"
          :disabled="isFullnameAndEmailRequired || isOnlyEmailRequired"
          type="submit"
          :loading-spinner="isLoading"
          value="Continue"
        />
      </div>
    </form>
  </create-account-layout>
</template>

<script>
import { mapState } from 'vuex';

import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';

// Common
import { formatFirstLastName } from '@/common/validators';
import { toastResponse } from '@/common/handleServerResponse';

//Mixin
import fullnameAndEmailField from '@/mixins/fullnameAndEmailField';

export default {
  name: 'GeneralInformation',
  components: {
    CreateAccountLayout,
    ButtonMain,
    FormField,
  },
  mixins: [fullnameAndEmailField],
  data() {
    return {
      isLoading: false,
      seeMore: false,
      showVerifyAccountModal: false,
    };
  },
  computed: {
    ...mapState({
      isEmailRequiredForLogin: (state) =>
        state.carriers?.isEmailRequiredForLogin || false,
      currentUserEmail: (state) => state.users?.currentUser?.email,
      userRequestedCarrierId: (state) =>
        state.users?.currentUser?.requested_carrier_id || null,
    }),
    isFullnameAndEmailRequired() {
      return (
        (!(this.full_name && this.email_address) ||
          !!(this.full_name_error_sw || this.email_address_error)) &&
        !this.isEmailRequiredForLogin
      );
    },
    isOnlyEmailRequired() {
      return (
        (!this.full_name || !!this.full_name_error_sw) &&
        this.isEmailRequiredForLogin
      );
    },
    isChallengeRequired() {
      return (
        this.$store.state.verifications?.challenge_question_required || false
      );
    },
  },
  watch: {
    userRequestedCarrierId: {
      handler: function (val) {
        let self = this;
        console.log('userRequestedCarrierId running: id == ' + val);
        if (val == '393180' && process.env.NODE_ENV == 'staging') {
          self.$store.commit('verifications/setRequireChallenge', true);
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    const findInput = document.querySelector('#full_name');
    setTimeout(() => {
      findInput.focus();
    }, 0);

    await this.$store.dispatch('users/refreshCurrentUser');
    let currentUser = this.$store.state.users.currentUser;

    // Redirect to the home page if the user is already associated with a company
    // unless the user's company is a broker that is still in the process
    // of claiming a carrier
    if (
      currentUser?.company?.id &&
      !(
        currentUser?.company?.company_type == 'broker' &&
        !currentUser?.company?.carrier_id
      )
    ) {
      this.$router.push({ name: 'Home' });
    }
    if (
      currentUser?.first_name &&
      currentUser?.last_name &&
      currentUser?.email
    ) {
      this.$router.push({ name: 'FMSCAAccountVerification' });
    }
  },
  methods: {
    async handleBigCarrierSubmit() {
      const res = await this.$store.dispatch('users/hasCarrierBeenClaimed');
      if (res.status === 200) {
        this.$store.commit('carriers/setMaskedContacts', res.data);
      }
      if (this.isChallengeRequired == true) {
        this.$router.push({
          name: 'VerificationChallenge',
        });
      } else if (res.status === 200) {
        this.$router.push({
          name: 'RequestAccessFMSCA',
          params: { carrierHasBeenClaimed: true },
        });
      } else if (res.status === 404) {
        if (this.isChallengeRequired == true) {
          this.$router.push({
            name: 'VerificationChallenge',
          });
        } else {
          this.$router.push({
            name: 'FMSCAAccountVerification',
            params: { canMoveOn: true },
          });
        }
      } else {
        toastResponse(this, res, null);
      }
    },
    async handleSubmit() {
      this.isLoading = true;
      const { first_name, last_name } = formatFirstLastName(this.full_name);

      const userRes = await this.$store.dispatch('users/patchSignUpDetails', {
        first_name,
        last_name,
        email: this.isEmailRequiredForLogin
          ? this.currentUserEmail
          : this.email_address,
      });

      if (this.isEmailRequiredForLogin) {
        this.handleBigCarrierSubmit();
        return;
      }

      if ([200, 201].includes(userRes.status)) {
        if (this.isChallengeRequired == true) {
          this.$router.push({
            name: 'VerificationChallenge',
          });
        } else {
          const res = await this.$store.dispatch('users/hasCarrierBeenClaimed');
          if (res.status === 200) {
            this.$store.commit('carriers/setMaskedContacts', res.data);
          }
          if (res.status === 200) {
            this.$router.push({
              name: 'RequestAccessFMSCA',
              params: { carrierHasBeenClaimed: true },
            });
          } else if (res.status === 404) {
            this.$router.push({
              name: 'FMSCAAccountVerification',
              params: { canMoveOn: true },
            });
          } else {
            toastResponse(this, res, null);
          }
        }
      } else {
        // handle error for updating user details
        toastResponse(this, userRes, null);
      }
      this.isLoading = false;
    },
  },
};
</script>
<style scoped>
p {
  @apply text-sm !important;
}
</style>
